import type { Document, DocumentAudience, DocumentCategory, DocumentStatus } from '@/api/types';

export type { Document, DocumentAudience, DocumentCategory, DocumentStatus };

/** The upload-modal's fixed category/audience options (PLAN-FASE3.md
 * WP-03) — a code choice, not something the API enumerates, same spirit as
 * `php/api_documents.php`'s own constants. */
export const CATEGORIES: DocumentCategory[] = [
  'algemeen',
  'beleid',
  'veiligheid',
  'hr',
  'vitaliteit',
];

export const AUDIENCES: DocumentAudience[] = [
  'iedereen',
  'management',
  'per_afdeling',
  'per_locatie',
];
